export type SituacaoBadgeVariant = 'brand' | 'neutral' | 'error' | 'warning' | 'success' | 'info';

const SITUACOES_AGUARDANDO_PAGAMENTO = new Set(['AGUARDANDO_PGTO', 'AGUARDANDO_PAGAMENTO']);

const SITUACOES_PAGAMENTO_VENCIDO = new Set(['PGTO_VENCIDO', 'PAGAMENTO_VENCIDO']);

export function isSituacaoAguardandoPagamento(key: string | null | undefined): boolean {
  return !!key && SITUACOES_AGUARDANDO_PAGAMENTO.has(key.toUpperCase());
}

export function isSituacaoPagamentoVencido(key: string | null | undefined): boolean {
  return !!key && SITUACOES_PAGAMENTO_VENCIDO.has(key.toUpperCase());
}

export function situacaoBadgeVariant(key: string | null | undefined): SituacaoBadgeVariant {
  if (isSituacaoPagamentoVencido(key)) return 'error';
  if (isSituacaoAguardandoPagamento(key)) return 'warning';
  return 'neutral';
}
